module.exports = __webpack_public_path__ + "img/Article.6e26df05.jpg";